import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { IDeleteApiResponse, IError, apiLimit } from "../../utils/api.types";

import {
  AInvoices,
  InvoiceFetch,
  IDispatchApiResponse,
  InvoicePreviewPayload,
} from "../../utils/invoice.types";

import {
    EstimateFormInputs,
    EstimateResponse,
    EstimateSeqNumber,
    AEstimates,
    EstimateFetch,
    EstimatePreviewResponse,
    AEstimateResponse,
    AEstimateUpdatePayload,
    EstimateDispatch,
  } from "../../utils/estimate.types";

// import {
//     EstimateFormInputs,
//     EstimateResponse
//   } from "../../utils/estimate.types";

// Fetch EstimateSeqNumber async thunk.
export const fetchEstimateSeqNumber = createAsyncThunk(
    'sale/fetchEstimateSeqNumber',
    async (): Promise<EstimateSeqNumber> => {
        const response = await axios.get(`/api/v1/sales/estimate/seq-number`);
  
        return response.data
    }
);

//Add Estimate async Thunk.
export const addEstimate = createAsyncThunk(
    'sale/addEstimate',
    async (estimatePayload: EstimateFormInputs): Promise<EstimateResponse> => {
        const response = await axios.post(`/api/v1/sales/estimate/create`, estimatePayload);
  
        return response.data
    }
);

/**
 * Fetch Invoices async thunk.
*/
export const fetchEstimates = createAsyncThunk(
    'sales/fetchEstimates',
    async ({accountId, type, params} : InvoiceFetch): Promise<AEstimates> => {
        let path = (type==='sale-estimate') ? `${accountId}/estimate/` : `${accountId}/delivery-note`
        let queryParam = (params)? `&${params}`: ''
        const response = await axios.get(`/api/v1/sales/account/${path}?limit=${apiLimit.limit}${queryParam}`);
        return response.data;
    }
);

export const selectedEstimateID = createAction("sales/selectedEstimateID", (estimateId) => {
    return {
        type: 'invoice/selectedInvoiceID',
        payload: estimateId
    }
});

/**
 * Update Estimate async Thunk.
 */
 export const updateEstimate = createAsyncThunk<
 AEstimateResponse,
 AEstimateUpdatePayload,
 {
     rejectValue: IError,
 }
>(
 'estimate/updateEstimate',
 async ({ id, estimatePayload }: AEstimateUpdatePayload, thunkApi) => {
     try {
         const response = await axios.put(`/api/v1/sales/estimate/${id}`, estimatePayload);

         const { data } = response;

         if (response.status === 200) {
             return data;
         }

         return thunkApi.rejectWithValue(data.error);
     } catch (error: any) {
         return thunkApi.rejectWithValue(error.response.data);
     }
 }
);

//Dispatch sale async Thunk.
export const dispatchSale = createAsyncThunk(
    'sales/dispatchSale',
    async ({saleId, saleType, params, dispatchPayload}: EstimateDispatch): Promise<IDispatchApiResponse> => {
        let queryParam = (params)? `?${params}`: ''
        console.log(saleType)
        const response = await axios.post(`/api/v1/sales/share/${saleType}/${saleId}/dispatch${queryParam}`, dispatchPayload);
  
        return response.data
    }
);

/**
 * Fetch Estimates By Id async thunk.
*/
export const fetchEstimateById = createAsyncThunk(
    'estimates/fetchEstimateById',
    async (id: string): Promise<AEstimates> => {
        const response = await axios.get(`/api/v1/sales/estimate/${id}`);
        return response.data;
    }
);

/**
 * Delete Estimate async Thunk.
 */
export const deleteEstimate = createAsyncThunk(
    'estimate/deleteEstimate',
    async (id: string): Promise<IDeleteApiResponse> => {
        const response = await axios.delete(`/api/v1/sales/estimate/${id}`);

        response.data['id'] = id;

        return response.data
    }
);


export const fetchEstimatePreview = createAsyncThunk<EstimatePreviewResponse,
InvoicePreviewPayload,
{
    rejectValue: IError,
}
 >(
    'estimate/preview',
    async ({invoiceId, templateId}: InvoicePreviewPayload, thunkApi) => {

        try {
            const response = await axios.get(`/api/v1/sales/invoice-preview/${invoiceId}/templates/${templateId}`);
            const { data } = response;
            if (response.status === 200) {
                return data;
            }
            return thunkApi.rejectWithValue(data.error);
        } catch (error: any) {
            return thunkApi.rejectWithValue(error.response.data);
        }
       
    }
);
